var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.user &&
    ((_vm.user.level && _vm.user.level > 1) ||
      (_vm.user.leveling_progress && _vm.user.leveling_progress.current_level > 1)) &&
    _vm.user.user_id !== '1'
  )?_c('span',{staticClass:"user-level-badge",class:[_vm.returnVipString(_vm.user.vip_state)],style:({ 'font-size': _vm.fontSize ? _vm.fontSize : '12px' })},[_vm._v(" "+_vm._s(_vm.user.level || (_vm.user.leveling_progress && _vm.user.leveling_progress.current_level))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }